import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/EN.json';
import frTranslation from './locales/FR.json';
import deTranslation from './locales/DE.json';
import itTranslation from './locales/IT.json';
import esTranslation from './locales/ES.json';
import ptTranslation from './locales/PT.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation,
    },
    fr: {
      translation: frTranslation,
    },
    de: {
      translation: deTranslation,
    },
    it: {
      translation: itTranslation,
    },
    es: {
      translation: esTranslation,
    },
    pt: {
      translation: ptTranslation,
    }
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
